import { WEBSITE_USE_API } from '../config'
import { putLocalAsset } from './localAssets'

/**
 * Where a picked photo goes.
 *
 * The one function this feature has to change when `menu_core_be` grows a
 * websites domain. Every existing upload route there is bound to a row the
 * permission guard can name, and a page element has no such row, so today the
 * photo stays in this browser and the document holds a `local:` reference.
 *
 * When the route exists, this posts the same multipart body the rest of the app
 * posts (a single field called `file`) and returns the URL it answers with, at
 * which point nothing else in the builder changes: a reference is a reference.
 */
export async function uploadAsset(blob: Blob, name: string): Promise<string> {
  if (WEBSITE_USE_API) {
    /*
      const body = new FormData()
      body.append('file', new File([blob], name, { type: blob.type }))
      const { data } = await api.post(`${WEBSITE_ENDPOINT}/assets`, body)
      return data.imageUrl
    */
    throw new Error('website asset upload is not wired to the API yet')
  }

  return putLocalAsset(blob, name)
}
